module.exports = __webpack_public_path__ + "static/media/mockup-map-presentation.fc6d4c75.png";